import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatTableModule } from '@angular/material/table';

type shortData = Record<string, string | number>;
interface columnData {
  columnName: string;
  tableHeaderName: string;
  valuePropertyName: string;
}

@Component({
  selector: 'app-short-table, [app-short-table]',
  imports: [MatTableModule],
  templateUrl: './short-table.component.html',
  styleUrl: './short-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ShortTableComponent {
  @Input() dataSource: shortData[] = [];
  @Input() columns: columnData[] = [];
  @Input() inheritColors = true;

  protected getDisplayedColumns() {
    return this.columns.map((column) => column.columnName);
  }
}
